var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiveCameraHoverIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 3,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0909 15.5455V19.9091H14.4545M19.9091 14.4545V10.0909H15.2727M19.9091 10.0909L14.7273 15.2727M8 24H22C23.1046 24 24 23.1046 24 22V8C24 6.89543 23.1046 6 22 6H8C6.89543 6 6 6.89543 6 8V22C6 23.1046 6.89543 24 8 24Z",
    stroke: "#11334E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveCameraHoverIcon);
export default __webpack_public_path__ + "static/media/LiveCameraHoverIcon.d329683941350f3a2ac1066920ca8234.svg";
export { ForwardRef as ReactComponent };